module.exports = __webpack_public_path__ + "img/arrow-left-1.7b36a36c.svg";